var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircleMRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM8.87417 5.41083C8.8075 4.74333 9.3325 4.16667 10 4.16667C10.6675 4.16667 11.1925 4.74333 11.1258 5.41083L10.4583 12.0858C10.4342 12.3208 10.2367 12.5 10 12.5C9.76333 12.5 9.56583 12.3208 9.54167 12.085L8.87417 5.41083ZM10 16.0417C9.425 16.0417 8.95833 15.575 8.95833 15C8.95833 14.425 9.425 13.9583 10 13.9583C10.575 13.9583 11.0417 14.425 11.0417 15C11.0417 15.575 10.575 16.0417 10 16.0417Z",
    fill: "#E86247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleMRed);
export default __webpack_public_path__ + "static/media/info-circle-m-red.2d3d7634fa3ea578f53f1bf99395c065.svg";
export { ForwardRef as ReactComponent };